// extracted by mini-css-extract-plugin
export default {"input_block":"addCategory_input_block__c0e0U","input_block_title":"addCategory_input_block_title__tyTyZ"};